import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import { dataToScriptsList } from '../parsings'

export default function useGetScriptsList() {
  const Api = useApi()

  const { filters, onSearch, onPageChange, onSortingChange } = useFilters({
    limit: 30,
    page: 1,
    filter: true,
    sort_by: 'updated_at',
    sort_order: 'desc',
  })
  const { data: response, isFetching } = Api.useGetQuery(`/storefronts/script/manager/scripts`, {
    queryId: 'storefront-scripts-list',
    filters: filters,
  })

  return {
    scriptsList: dataToScriptsList(response?.data || []),
    pagination: response?.pagination || {},
    isLoading: isFetching,
    filters,
    onSearch,
    onPageChange,
    onSortingChange,
  }
}
